import React from 'react'
import { IconsModel } from './iconsModel'

const SvgAlone = (
	{
		color,
		width = 30,
		height = 46
	}: IconsModel
) => (
	<svg width={width} height={height} viewBox={`0 0 30 42`}>
		<g transform="translate(0.25 0.25)">
			<path
				d="M66.233,52.425a7.453,7.453,0,1,1,7.453-7.453A7.461,7.461,0,0,1,66.233,52.425Zm0-13.338a5.885,5.885,0,1,0,5.885,5.885A5.891,5.891,0,0,0,66.233,39.087Z"
				transform="translate(-52.111 -37.519)"
				fill={color}
				stroke={color}
			/>
			<path
				d="M44.5,168.727H20.379a4.123,4.123,0,0,1-4.119-4.119V151.271a7.462,7.462,0,0,1,7.453-7.453h2.12l.226.392a4.989,4.989,0,0,0,8.645,0l.227-.392h2.12a7.462,7.462,0,0,1,7.453,7.453ZM23.713,145.386a5.891,5.891,0,0,0-5.885,5.885v13.338a2.553,2.553,0,0,0,2.55,2.55H42.935V151.271a5.891,5.891,0,0,0-5.885-5.885H35.817a6.556,6.556,0,0,1-10.87,0Z"
				transform="translate(-16.26 -127.146)"
				fill={color}
				stroke={color}
			/>
			<path
				d="M212.6,148.819"
				transform="translate(-181.805 -131.363)"
				fill={color}
				stroke={color}
			/>
		</g>
	</svg>
)

export default SvgAlone
